module.exports = __webpack_public_path__ + "img/enterGGKT2.120534f1.jpg";